import './index.scss';
import {handleApiError} from 'utils/api_error_handler';

class ExamRequestModal {
  static _renderTemplate(template, data) {
    return template.replace('$examName', data.title);
  }

  static _confirm(e) {
    Thor.Exam.request({id: e.data.data.id}).then(() => {
      e.data.caller.text('Pedido realizado');
      e.data.caller.prop('disabled', true);
    }).catch(({response}) => {
      if (response.status === 422) {
        e.data.caller.text('Pedido realizado');
        e.data.caller.prop('disabled', true);
      } else {
        handleApiError('Ops! Não foi possível realizar o seu pedido nesse momento!', response);
      }
    });

    const $modal = $(e.currentTarget).parents('.js-exams-request-modal');
    $modal.find('.js-first-step').hide();
    $modal.find('.js-modal-footer').hide();
    $modal.find('.js-last-step').css('display', 'inline-block');
  }

  static show(exam, caller) {
    const $page = $('.js-q-exams-page');
    const template = this._renderTemplate($('#js-exam-request-modal-template').html(), exam);
    const $modal = $(template);

    $page.append($modal);
    $modal.modal();

    $modal.find('.js-confirm-btn').on('click', {data: exam, caller: caller}, this._confirm);

    $modal.on('hidden.bs.modal', () => {
      $modal.remove();
    });

    $modal.modal('show');
  }
}

export default ExamRequestModal;
